import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import ActionMenu from "../../../../../components/app/ActionMenu";
import HcpcsCatalogDrawer from "../../../../../components/app/admin/Library/catalog/HcpcsCatalogDrawer";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import ToggleSwitch from "../../../../../components/ToggleSwitch";
import { hcpcsCodeCatalogInitialValuesType } from "../../../../../constants/initial-schemas";
import { HcpcsCodeCatalogType } from "../../../../../dummy-data/hcpcs-code-catalog";
import useDisclosure from "../../../../../hooks/use-disclosure";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { useArchiveCatalogCode } from "../../../../../queries/catalog/use-archive-catalog-code";
import useGetCataLogCode from "../../../../../queries/catalog/use-get-catalog-code";
import { useStatusUpdateCatalogCode } from "../../../../../queries/catalog/use-status-update-catalog-code";
import {
  DEFAULT_PAGE_SIZE,
  applyDefaultColumnSettings,
  DGT_Pagination,
  filterActionCol,
  getSuccessSnackbar,
  isAdmin,
} from "../../../../../utils/utils";
// import { GlobalTableHeightWrapper } from "../../../../../components/GlobalTableHeightWrapper";
import PageLayout from "../../../../../components/PageLayout";
import {
  CATALOG_ACTION,
  CATALOG_ACTIVE_ACTIONS,
  CATALOG_ARCHIVED_ACTIONS,
} from "./catalog-constant";
import { CatalogOutletContext } from "./catalog-types";
import { useCatalogCodeAccess } from "./hooks/use-catalog-code-access";

const CatalogHCPCSCodeCatalog = () => {
  const { search: searchKey, isArchieved: archived } =
    useOutletContext<CatalogOutletContext>();
  const hasMasterData = useCatalogCodeAccess("HCPCS");

  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const {
    data,
    refetch,
    isLoading: isTableLoading,
    isFetching,
  } = useGetCataLogCode({
    gridSorting,
    pagination,
    searchKey,
    type: "HCPCS",
    active: undefined,
    archive: archived,
  });
  const showSnackbar = useSnackbar();

  const { mutateAsync: updateStatus } = useStatusUpdateCatalogCode();
  const { mutateAsync: deleteHcpcsCode } = useArchiveCatalogCode();

  const [editHcpcsCodeValues, setEditHcpcsCodeValues] =
    useState<hcpcsCodeCatalogInitialValuesType>();
  const [uuid, setUuid] = useState<string>();

  const hcpcsEditModalDisclosure = useDisclosure(false);

  // const {
  //   opened: openedDeleteModal,
  //   open: openDeleteModal,
  //   close: closeDeleteModal,
  //   deleteId,
  // } = useDeleteDisClosure(false);

  const COLUMNS = applyDefaultColumnSettings<HcpcsCodeCatalogType>([
    {
      field: "code",
      headerName: "HCPCS Code",
      flex: 0.5,
      minWidth: 180,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      minWidth: 500,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "active",
      headerName: "Status",
      sortable: false,
      disableColumnMenu: true,
      width: 150,
      renderCell: ({ row, value }) => (
        <ToggleSwitch
          id={row.uuid.toString()}
          checked={value}
          onConfirm={(status, id) =>
            updateStatus({ medicalCodeId: id as string, status }).then(
              (res) => {
                refetch();
                return res;
              }
            )
          }
        />
      ),
    },
    {
      field: "Action",
      width: 90,
      hideSortIcons: true,
      renderCell: ({ row }) => {
        return (
          <ActionMenu
            options={
              row?.archive ? CATALOG_ARCHIVED_ACTIONS : CATALOG_ACTIVE_ACTIONS
            }
            onActionClick={(v) => {
              if (v === CATALOG_ACTION.EDIT) {
                const values = {
                  hcpcs_code: row?.code,
                  description: row?.description,
                };
                setUuid(row.uuid?.toString());

                setEditHcpcsCodeValues(values);
                hcpcsEditModalDisclosure.open();
              } else {
                deleteHcpcsCode({
                  medicalCodeId: row?.uuid?.toString() as string,
                  archive: v === CATALOG_ACTION.ARCHIVE,
                }).then((res) => {
                  refetch();
                  showSnackbar(getSuccessSnackbar(res));
                  return res;
                });
              }
            }}
          />
        );
      },
    },
  ]);
  return (
    <PageLayout>
      {/* <DeleteModal
        w="380px"
        open={openedDeleteModal}
        onClose={closeDeleteModal}
        id={deleteId}
        onConfirmation={(id) =>
          deleteHcpcsCode({ medicalCodeId: id as string }).then((res) => {
            refetch();
            return res;
          })
        }
        content={"You want to delete this HCPCS Code"}
      /> */}
      <HcpcsCatalogDrawer
        initialValues={editHcpcsCodeValues}
        disclosureHost={hcpcsEditModalDisclosure}
        dialogTitle="Edit HCPCS Code"
        uuid={uuid}
      />
      <CustomDataGridV2
        loading={isTableLoading || isFetching}
        searchString={searchKey}
        rows={data?.data?.content ?? []}
        getRowId={(row) => row?.uuid}
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setGridSorting}
        rowCount={data?.data?.page?.totalElements ?? 10}
        columns={filterActionCol(COLUMNS, !isAdmin() ? !hasMasterData : false)}
        disableRowSelectionOnClick
      />
    </PageLayout>
  );
};

export default CatalogHCPCSCodeCatalog;
